<template>
  <div class="course-box">
    <div class="d-flex flex-align-center flex-justify-between">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <!--        <el-breadcrumb-item :to="{ path: '/participation/train' }">参加培训任务</el-breadcrumb-item>-->
        <!--        <el-breadcrumb-item :to="{ path: '/participation/course' }">计划课程</el-breadcrumb-item>-->
        <el-breadcrumb-item>参加培训任务</el-breadcrumb-item>
        <el-breadcrumb-item>计划课程</el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button size="small" class="mg-btm20 mg-rgt20" @click="$router.back()">返回</el-button>
    </div>
    <div class="file-box">
      <div class="file-left">
        <div class="fz18 mg-btm10">{{ detailData.courseName }}</div>
        <div v-for="(item, index) in detailData.material" :key="index" @click="materialClick(item)"
          :class="{ 'item-active': item.fileKey === activeData.fileKey }" class="left-item">
          <div class="">{{ item.name }}</div>
          <i v-buttonAuth="'system:participationTrain:downloadFile'" @click.stop="materialDown(item)"
            class="el-icon-download fz18 mg-lef20"></i>
        </div>
      </div>
      <div v-loading="fileLoading" element-loading-text="资源较大，拼命加载中..." element-loading-background="rgba(0, 0, 0, 0.8)"
        class="file-right">

        <div v-if="activeData.suffix" style="height: 100%;overflow: hidden;">
          <div v-show="['mp4', 'avi', 'wmv', 'mpeg', 'flv', 'rm'].includes(activeData.suffix.toLowerCase())"
            class="VideoPlayer">
            <video ref="videoPlayer" class="video-js">抱歉，您的浏览器不支持</video>
          </div>
          <reviewOffice
            v-if="['pdf', 'docx', 'doc', 'xls', 'xlsx', 'png', 'jpg', 'jpeg'].includes(activeData.suffix.toLowerCase())"
            :type="activeData.suffix" :url="URL + activeData.fileKey"></reviewOffice>
        </div>
      </div>
      <div class="file-right-main">
        <div class="review-input ">
          <div class="d-flex flex-align-center mg-btm10">
            <i class="el-icon-chat-dot-square fz30"></i>
            <span class="fz26 mg-lef5">评论（{{ commentCount }}）</span>
          </div>
          <div class="d-flex flex-column review-person" v-if="replyData.courseCommentId">
            <span>回复 {{ replyData.createdBy.userName }}</span>
            <span>{{ replyData.oldCommentContent }}</span>
          </div>
          <div class="d-flex flex-align-center ">
            <div class="flex-1" v-if="!replyData.courseCommentId">
              <el-avatar :size="50" :src="avatar"></el-avatar>

            </div>
            <el-input type="textarea" class="mg-lef5" :rows="3" placeholder="请输入内容" v-model="replyData.commentContent">
            </el-input>
          </div>
          <div class="d-flex mg-tp10 flex-justify-end">
            <el-button type="primary" @click="submitReply()" size="mini">发送</el-button>
            <el-button size="mini" @click="cancelReply()">取消</el-button>
          </div>
        </div>
        <div class="mg-tp20 review-main">
          <div class="review-cells" v-for="item in commentList" :key="item.courseCommentId">
            <div class="mg-tp10 review-cell">
              <div class="d-flex flex-align-start ">
                <div class="">
                  <el-avatar :size="50" :src="item.createUserAvatar"></el-avatar>
                </div>
                <div class="mg-lef10 d-flex flex-column flex-1 commentContent">
                  <span>{{ item.createdBy.userName }}</span>
                  <div class="mg-tp5 ">{{ item.commentContent }}</div>
                  <div class="d-flex flex-align-center" style="color:#AAAAAA">{{ item.createTime }}
                    <el-button type="text" class="mg-lef10" @click="replayAction(item)">回复</el-button>
                    <el-popconfirm title="是否删除数据？" @confirm="handleRemove(item, 2)">
                      <template #reference>
                        <el-button type="text" v-if="item.ableDelete" class="col-f41">删除</el-button>
                      </template>
                    </el-popconfirm>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-align-start " v-for="child in item.children" :key="child.courseCommentId"
                style="margin-left:40px">
                <div>
                  <el-avatar :size="50" :src="child.createUserAvatar"></el-avatar>
                </div>
                <div class="mg-lef10 d-flex flex-column flex-1 commentContent">
                  <span>{{ child.createdBy.userName }} 回复 <a class="col-29f">{{ child.replyOriginUserName }} </a></span>
                  <span class="mg-tp5">{{ child.commentContent }}</span>
                  <div style="color:#AAAAAA">{{ child.createTime }}
                    <el-button type="text" class="mg-lef10" @click="replayAction(child)">回复</el-button>
                    <el-popconfirm title="是否删除数据？" @confirm="handleRemove(child, 2)">

                      <template #reference>
                        <el-button type="text" v-if="child.ableDelete" class="col-f41">删除</el-button>
                      </template>
                    </el-popconfirm>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="review-bottom d-flex  flex-align-center flex-justify-between">
          <el-button type="primary" :disabled="pageNum === 1" @click="pageNum--; getDetails()">上一页</el-button>
          <span>{{ pageNum }}/{{ pageTotal }}</span>
          <el-button type="primary" :disabled="pageNum === pageTotal" @click="pageNum++; getDetails()">下一页</el-button>
        </div>

      </div>
    </div>
    <el-dialog :visible.sync="centerDialogVisible" width="300px" center :close-on-click-modal='false'
      :close-on-press-escape="false" :show-close="false">
      <div style="font-size: 16px;">请输入验证码以确认您的身份</div>
      <div>
        <img :src="codeImg" alt="" class="codeimg">
        <el-input type="text" v-model="code" auto-complete="off" placeholder="请输入图形验证码"
          @keyup.enter.native="submitForm()"></el-input>
        <el-button type="primary" @click="submitForm()">确定</el-button>
      </div>
    </el-dialog>
    <div ref="websocketComponent">
    </div>
  </div>
</template>

<script>
import PublicSearch from '@/components/publicSearch.vue';
import reviewOffice from '@/components/reviewOffice'
import MyUpload from '@/components/myUpload.vue';
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myForm from '@/components/myForm.vue';
import myImportDialog from '@/components/myImportDialog.vue';
import api from '../../api/participationTrain/index';
import studyRecApi from '../../api/onlineTraining/studyRec';
import VueOfficePdf from '@vue-office/pdf';
import Video from 'video.js';
import store from "@/vuex/store";
import vuePdf from 'vue-pdf';
import 'video.js/dist/video-js.css';
import { fileDownload } from '../../utils/util';
import { courseReviewAdd, courseReviewPage, courseReviewRemove, courseReviewCount } from '@/api/courseReview.js'

import { configAdd, configList, configAddOrEdit } from '@/api/userMG.js'


export default {
  components: {
    PublicSearch,
    MyUpload,
    MyTable,
    Pagination,
    myForm,
    myImportDialog,
    VueOfficePdf,
    Video,
    vuePdf,
    reviewOffice
  },
  data () {
    return {
      trainCodeSwitch: false,
      trainCodeInterval: 1,
      avatar: store.state.userInfo.avatar || '',
      URL: envConfig.NODE_IMG_API,
      detailData: {},
      activeData: {},
      videoData: {
        player: null,
        option: {
          controls: true,
          preload: 'auto',
          sources: []
        }
      },
      fileLoading: false,
      pdfUrl: null,
      pageCount: 1,
      pageAllCount: 0,
      timeInterval: null,
      timeSecond: 0,
      replyData: {
        commentContent: '',
      },
      pageNum: 1,
      commentCount: 0,
      pageTotal: 0,
      commentList: [],
      centerDialogVisible: false,
      codeImg: '',
      code: '',
      timer: null,
      jitterTimer: null,
      endLearningType: '',

    }
  },
  created () {
    if (this.timeInterval) clearInterval(this.timeInterval);
    this.timeSecond = 0;
    this.timeInterval = setInterval(_ => {
      this.timeSecond = this.timeSecond + 1;
    }, 1000)
    this.getData();
    this.getDetails()
  },
  mounted () {
    window.addEventListener('beforeunload', this.beforeunload, true);
    window.addEventListener('keydown', this.preventKeydown, true);
    if (this.$store.state.websocketClient.connected) {
      this.$store.state.websocketClient.setHeartbeatStartedCallback(this.isVerfiyWebsocket());
      this.isVerfiyWebsocket()
    } else {
      this.timer = setInterval(() => {
        this.isVerfiyWebsocket()
      }, 1e3);
    }
  },
  methods: {
    isVerfiyWebsocket () {
      clearTimeout(this.timer);
      clearTimeout(this.jitterTimer);
      this.jitterTimer = setTimeout(() => {
        this.$store.state.websocketClient.sendMessage({
          type: 'start_learning',
          planId: this.$route.query.planId,
          courseId: this.$route.query.courseId
        });
        this.$store.state.websocketClient.setMessageReceivedCallback(this.handleMessageReceived);
      }, 300); // 设置防抖时间间隔，单位为毫秒
    },
    submitForm () {
      this.$store.state.websocketClient.sendMessage(
        {
          "type": "verify_code",
          code: this.code
        }
      );
      if (this.videoData.player) {
        this.videoData.player.play();
      }
      this.centerDialogVisible = false;
    },
    handleMessageReceived (message) {
      if (message.type == 'generate_code') {
        this.code = '';
        this.centerDialogVisible = true;
        this.codeImg = message.code;
        if (this.videoData.player) {
          this.videoData.player.pause();
        }
      } else if (message.type == 'end_learning') {
        this.endLearningType = message.endLearningType;
        if (message.endLearningType === 'verifyCodeTimeout') {
          this.centerDialogVisible = false;
          this.codeImg = '';
          this.$confirm(`${message.endLearningTypeText}`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.isVerfiyWebsocket()
          }).catch(() => {
            this.$router.back()
          });
        } else if (message.endLearningType === 'repeat') {
          this.$confirm(`${message.endLearningTypeText}`, '提示', {
            confirmButtonText: '确定',
            showCancelButton: false,
            showClose: false,
            type: 'warning'
          }).then(() => {
            this.$router.back()
          });

        }
      }
    },
    beforeunload () {
      const params = { planId: this.$route.query.planId, courseId: this.$route.query.courseId, studyTimes: this.timeSecond };
      studyRecApi.studyRecAdd(params).then(res => {
        if (this.timeInterval) {
          clearInterval(this.timeInterval);
          this.timeSecond = 0;
        }
      });
      // event.preventDefault();
      // event.returnValue = "";
    },
    preventKeydown (e) {
      const evt = window.event || e;
      const code = evt.keyCode || evt.which;
      if (code === 116) {
        if (evt.preventDefault) {
          evt.preventDefault();
        } else {
          evt.keyCode = 0;
          evt.returnValue = false
        }
      }
    },
    error (e) {
      console.log(e);
    },
    pdfLoad (e) {
      if (e === 1) {
        this.fileLoading = false;
      } else this.fileLoading = true;
    },
    materialDown (data) {
      fileDownload(envConfig.NODE_IMG_API + data.fileKey, data.name);
    },
    materialClick (data) {

      if (this.activeData.fileKey === data.fileKey) return false
      if (['mp4', 'avi', 'wmv', 'mpeg', 'flv', 'rm'].includes(data.suffix.toLowerCase())) {
        const mp4Url = ['avi', 'wmv', 'mpeg', 'flv', 'rm'].includes(data.suffix.toLowerCase()) ? data.newFileKey : data.fileKey
        const srcList = [{ src: this.URL + mp4Url, type: 'video/mp4' }]
        if (this.videoData.player) {
          this.videoData.player.src(srcList);
        } else {
          this.videoData.option.sources = srcList;
          setTimeout(() => {
            this.videoData.player = Video(this.$refs.videoPlayer, this.videoData.option, function () {
            });
          });
        }
      } else {
        if (this.videoData.player) {
          this.videoData.player.pause();
        }
        if (this.fileLoading) {
          this.$message.warning('上个资源还未加载完');
          return false;
        }
        this.pageCount = 1;
        this.fileLoading = false;
      }
      this.activeData = data;
    },
    //  获取数据
    async getData () {
      const res = await api.trainCourseDetail(this.$route.query.courseId);
      this.detailData = res.data;
      this.materialClick(res.data.material[0]);
    },
    async getDetails () {
      const params = {
        "courseId": this.$route.query.courseId,
        "pageNum": this.pageNum,
        "pageSize": 5
      }
      const res = await courseReviewPage(params);
      this.commentList = res.data.records;
      this.pageTotal = Math.ceil(res.data.total / 5);


      this.replyData = {
        commentContent: '',
      };
      const res1 = await courseReviewCount({ "courseId": this.$route.query.courseId });
      this.commentCount = res1.data

    },
    replayAction (item) {
      this.replyData = JSON.parse(JSON.stringify(item));
      this.replyData['oldCommentContent'] = JSON.parse(JSON.stringify(item)).commentContent;
      this.replyData['commentContent'] = '';
    },
    async submitReply () {
      if (!this.replyData.commentContent) {
        this.$message.warning('请输入回复内容');
        return
      };
      const params = {
        commentContent: this.replyData.commentContent || '',
        replyOriginCommitId: this.replyData.courseCommentId || '',
        courseId: this.$route.query.courseId || '',
      }
      const res = await courseReviewAdd(params);
      this.getDetails()
    },
    cancelReply () {
      this.replyData = {
        commentContent: '',
      }
    },
    async handleRemove (row, type = 1) {
      const res = await courseReviewRemove(row.courseCommentId);
      this.pageNum = 1;
      this.getDetails()
      this.$message({ message: '删除成功', type: 'success' });
    },
  },
  beforeRouteLeave (to, form, next) {
    this.beforeunload();
    next();
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.beforeunload, true);
    window.removeEventListener('keydown', this.preventKeydown, true);
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
      this.timeSecond = 0;
    }
    this.videoData.player && this.videoData.player.dispose();
    this.$store.state.websocketClient.setMessageReceivedCallback(null)
    if (this.endLearningType !== 'repeat') {
      this.$store.state.websocketClient.sendMessage(
        {
          "type": "end_learning",
        }
      );
    }

  },


}
</script>

<style lang="scss" scoped>
.commentContent {
  overflow: hidden;
  word-wrap: break-word;
  word-break: normal;
}

.course-box {
  height: 100%;
  display: flex;
  flex-direction: column;

  .el-breadcrumb {
    padding: 0 20px;
  }

  .file-box {
    display: flex;
    flex: 1;
    flex-basis: 0;
    overflow: hidden;
    padding: 20px;

    .file-left {
      width: 20%;
      padding: 20px 20px 20px 0;
      border-right: 1px solid #f2f2f2;

      .left-item {
        padding: 10px;
        cursor: pointer;
        margin-left: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        &:hover {
          background-color: #f2f2f2;
          border-radius: 5px;
        }
      }

      .item-active {
        background-color: #f2f2f2;
        border-radius: 5px;
      }
    }

    .file-right {
      flex: 1;
      padding: 20px;

      .pdf-btn {
        width: 80%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 auto;
      }

      .pdfView-box {
        width: 80%;
        height: 1000px;
        margin: 0 auto;
        border: 1px solid #f2f2f2;
        overflow: hidden;
        position: relative;

        .loading-box {
          //height: 100%;
        }
      }

      .pdfView-auto {
        overflow-y: auto;
      }

      .VideoPlayer {
        position: relative;
        width: 80%;
        height: 700px;
        margin: 0 auto;

        .video-js {
          width: 100%;
          height: 100%;
          background: #faf6fa;
        }
      }
    }
  }

  .file-right-main {
    flex: 0.5;
    padding: 20px;
    flex-basis: 0;
    overflow: hidden;
    box-sizing: border-box;
    border-left: 1px solid #f2f2f2;
    display: flex;
    flex-direction: column;

    .review-main {
      flex: 1;
      flex-basis: 0;
      overflow-y: auto;
    }
  }
}

.review-cell {
  padding-top: 20px;
  border-top: 1px solid #333333;

}

.board-input {
  display: flex;
  align-items: center;
}

.review-person {
  padding-top: 10px;
  padding-left: 20px;
  box-sizing: border-box;
  border-top: 1px solid #f2f2f2;

  span {
    color: rgba(51, 51, 51, 0.8);
    font-size: 14px;
    width: 100%;
    margin-top: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:first-child {
      color: rgba(51, 51, 51, 0.6);

    }
  }
}
</style>

<style lang="scss">
.el-loading-mask {
  z-index: 5000 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/participationTrain/courseDetail.vue